import { render, staticRenderFns } from "./DetailsSwiper.vue?vue&type=template&id=568bd9fe&scoped=true&"
import script from "./DetailsSwiper.vue?vue&type=script&lang=js&"
export * from "./DetailsSwiper.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSwiper.vue?vue&type=style&index=0&id=568bd9fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568bd9fe",
  null
  
)

export default component.exports